module.exports = __webpack_public_path__ + "media/images/MainPhoto-27575a9a.jpg";